module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-box"
  }, [_c('div', {
    staticClass: "principal-chart"
  }, [_vm._m(0), _vm._m(1), (_vm.showDetail) ? _c('div', {
    staticClass: "arrow arrow-referred"
  }, [_c('div', {
    staticClass: "curve"
  }), _c('div', {
    staticClass: "point"
  })]) : _vm._e(), _c('span', {
    staticClass: "description description-fee"
  }, [_vm._v("Platform's fee")]), _c('span', {
    staticClass: "description description-miner"
  }, [_vm._v(_vm._s(_vm.minerText))]), (_vm.showDetail) ? _c('span', {
    staticClass: "description description-referred",
    style: ('left: calc(50% - ' + _vm.referredTextPosition + 'px);')
  }, [_vm._v(_vm._s(_vm.referredText))]) : _vm._e(), _c('div', {
    staticClass: "fee",
    style: ('width: ' + (_vm.showDetail ? _vm.widthDetailFee : _vm.widthPrincipalFee) + '%;')
  }, [(_vm.showDetail) ? _c('span', {
    staticClass: "percentage percentage-very-small"
  }, [_c('span', [_vm._v(_vm._s(_vm.tier.platform_percentage) + "%")])]) : _c('span', {
    staticClass: "percentage percentage-very-small"
  }, [(_vm.withRefCode) ? _c('span', [_vm._v("0.75%")]) : _c('span', [_vm._v("1%")])])]), (_vm.showDetail) ? _c('div', {
    staticClass: "referred",
    style: ('width: ' + _vm.widthDetailReferred + '%;' + (_vm.showDetail ? 'z-index:9;' : 'min-width:40px;'))
  }, [_c('span', {
    staticClass: "percentage percentage-small"
  }, [_vm._v(_vm._s(_vm.tier.owner_percentage) + "%")])]) : _vm._e(), _c('div', {
    staticClass: "miner-bar",
    class: {
      'detailed-view': _vm.showDetail
    },
    style: ('width: ' + _vm.widthPrincipalMiner + '%;')
  }, [(_vm.withRefCode || _vm.showDetail) ? _c('span', {
    staticClass: "percentage"
  }, [_vm._v("99.25%")]) : _c('span', {
    staticClass: "percentage"
  }, [_vm._v("99%")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow arrow-fee"
  }, [_c('div', {
    staticClass: "curve"
  }), _c('div', {
    staticClass: "point"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow arrow-miner"
  }, [_c('div', {
    staticClass: "curve"
  }), _c('div', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c3df0f","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_referral_image.vue
// module id = 363
// module chunks = 1